import { NgModule } from '@angular/core';

import { SliderComponent } from './slider.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    exports: [SliderComponent],
    declarations: [SliderComponent],
    providers: [],
})
export class SliderModule { }
